// extracted by mini-css-extract-plugin
export default {"container":"container__FileDropZoneOutline__m8iiw"};